import React, { useRef, useState } from "react";
import DownloadExcel from "../../../Extra/DownloadExcel";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import {
  flattenData,
  getDaysBetweenMonths,
  secondsToHHMM,
} from "../../../Utilitie";

const STAYardPDDMWData = ({ data }) => {
  const key = [
    "TRAIN",
    "HRS",
    "AVG TRAIN",
    "AVR HRS",
    "TRAIN",
    "HRS",
    "AVG TRAIN",
    "AVR HRS",
    "TRAIN",
    "HRS",
    "AVG TRAIN",
    "AVR HRS",
  ];
  const tempData = data;

  const years = [...new Set(tempData.map((o) => o.f_year))];
  const monthOrder = [
    "APR",
    "MAY",
    "JUN",
    "JULY",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
    "JAN",
    "FEB",
    "MAR",
  ];
  const tableRef = useRef();
  const table1 = useRef();
  const table2 = useRef();
  const table3 = useRef();
  const table4 = useRef();
  const table5 = useRef();
  const tableRefArray = [table1, table2, table3, table4, table5];
  const sum = (year, column) => {
    return tempData
      .filter((o) => o.f_year === year)
      .reduce((s, o) => s + Number(o[column] || 0), 0);
  };

  const avg = (year, column) => {
    const items = tempData.filter((o) => o.f_year === year);
    const total = items.reduce((s, o) => s + Number(o[column] || 0), 0);
    return items.length ? (total / items.length).toFixed(2) : 0;
  };

  return (
    <div>
      {" "}
      <h6 className="p-3 bg-dark text-white">
        STA TRAFFIC FLOW FINANCIAL YEAR WISE SUMMARY
      </h6>
      <div className="table-responsive">
        {years.map((year, ind) => {
          return (
            <div>
              <table
                ref={tableRefArray[years.indexOf(year)]}
                className="table table-bordered table-striped text-center "
                style={{ fontSize: "13px" }}
              >
                <thead>
                  <tr className="table-dark text-center">
                    <th></th>
                    <>
                      <th colSpan={12}> STA YARD PDD ({year})</th>
                    </>
                  </tr>
                  <tr
                    className="table-dark text-center"
                    style={{ fontWeight: "bold" }}
                  >
                    <th></th>
                    <>
                      <th colSpan={4}>BY PASS TRAIN </th>
                      <th colSpan={4}>ORIGINATING TRAIN </th>
                      <th colSpan={4}>TOTAL </th>
                    </>
                  </tr>

                  <tr
                    className="table-dark text-center align-middle"
                    style={{ fontWeight: "bold" }}
                  >
                    <th>Month</th>

                    {key.map((Head, i) => (
                      <th
                        key={i}
                        style={{
                          whiteSpace: "normal",
                        }}
                      >
                        {Head.toUpperCase().replace("_", " ")}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody key={ind}>
                  {monthOrder.map((month, i) => {
                    let tempMonths = [
                      ...new Set(
                        tempData
                          .filter((x) => x.f_year === year)
                          .map((x) => x.a_month)
                      ),
                    ];

                    if (!tempMonths.includes(month)) return null;

                    const row = tempData.find(
                      (o) => o.f_year === year && o.a_month === month
                    );

                    return (
                      <tr key={i}>
                        <td>{month}</td>

                        <td>{row?.bpt_trains || 0}</td>
                        <td>{secondsToHHMM(row?.bpt_hrs) || 0}</td>
                        <td>{row?.bpt_avg_train || 0}</td>
                        <td>{secondsToHHMM(row?.bpt_avg_hrs) || 0}</td>

                        <td>{row?.ot_trains || 0}</td>
                        <td>{secondsToHHMM(row?.ot_hrs) || 0}</td>
                        <td>{row?.ot_avg_train || 0}</td>
                        <td>{secondsToHHMM(row?.ot_avg_hrs) || 0}</td>

                        <td>{row?.total_trains || 0}</td>
                        <td>{secondsToHHMM(row?.total_hrs) || 0}</td>
                        <td>{row?.total_avg_train || 0}</td>
                        <td>{secondsToHHMM(row?.total_avg_hrs) || 0}</td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr className="table-dark fw-bold">
                    <td>Total</td>

                    <td>{sum(year, "bpt_trains")}</td>
                    <td>{secondsToHHMM(sum(year, "bpt_hrs"))}</td>
                    <td>{sum(year, "bpt_avg_train")}</td>
                    <td>{secondsToHHMM(sum(year, "bpt_avg_hrs"))}</td>

                    <td>{sum(year, "ot_trains")}</td>
                    <td>{secondsToHHMM(sum(year, "ot_hrs"))}</td>
                    <td>{sum(year, "ot_avg_train")}</td>
                    <td>{secondsToHHMM(sum(year, "ot_avg_hrs"))}</td>

                    <td>{sum(year, "total_trains")}</td>
                    <td>{secondsToHHMM(sum(year, "total_hrs"))}</td>
                    <td>{sum(year, "total_avg_train")}</td>
                    <td>{secondsToHHMM(sum(year, "total_avg_hrs"))}</td>
                  </tr>

                  <tr className="table-dark fw-bold">
                    <td>Average</td>

                    <td>{avg(year, "bpt_trains")}</td>
                    <td>{secondsToHHMM(avg(year, "bpt_hrs"))}</td>
                    <td>{avg(year, "bpt_avg_train")}</td>
                    <td>{secondsToHHMM(avg(year, "bpt_avg_hrs"))}</td>

                    <td>{avg(year, "ot_trains")}</td>
                    <td>{secondsToHHMM(avg(year, "ot_hrs"))}</td>
                    <td>{avg(year, "ot_avg_train")}</td>
                    <td>{secondsToHHMM(avg(year, "ot_avg_hrs"))}</td>

                    <td>{avg(year, "total_trains")}</td>
                    <td>{secondsToHHMM(avg(year, "total_hrs"))}</td>
                    <td>{avg(year, "total_avg_train")}</td>
                    <td>{secondsToHHMM(avg(year, "total_avg_hrs"))}</td>
                  </tr>
                </tfoot>
              </table>{" "}
              <div className="mb-3">
                <DownloadExcel
                  tableRef={tableRefArray[years.indexOf(year)]}
                  fileName={`Financial Year Summary STA Yard Ex  - ${year}`}
                />
              </div>
            </div>
          );
        })}{" "}
      </div>{" "}
    </div>
  );
};

export default STAYardPDDMWData;
